// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4x-7";
export var adjustableWidthBorderHeld = "_4x-8";
export var arrow = "_4x-3";
export var arrowButton = "_4x-4";
export var headerCell = "_4x-0";
export var help = "_4x-2";
export var icon = "_4x-1";
export var iconWrapper = "_4x-6";
export var noBorder = "_4x-b";
export var nonAdjustableWidthBorder = "_4x-9";
export var nonAdjustableWidthBorderHeld = "_4x-a";
export var textButton = "_4x-5";